// extracted by mini-css-extract-plugin
module.exports = {"CheckboxButton":"classes_CheckboxButton__2U6yd","buttonCheckBox2":"classes_buttonCheckBox2__A3RuV"};